import { Suspense } from "react";

import { useRootSelector } from "store/hooks";

import { ComingSoon } from "components/sliderPage/comingSoon/ComingSoon";
import { ManageWallet } from "components/sliderPage/manageWallet/ManageWallet";
import { Confirmation } from "components/sliderPage/manageWallet/confirmation/Confirmation";
import { PaymentDetail } from "components/sliderPage/paymentDetail/PaymentDetail";
import { MakePayment } from "components/sliderPage/makePayment/MakePayment";
import { ReviewPayment } from "components/sliderPage/makePayment/reviewPayment/ReviewPayment";
import { Confirmation as MakeAPaymentConfirmation } from "components/sliderPage/makePayment/confirmation/Confirmation";
import { DeleteConfirmation } from "components/sliderPage/manageWallet/deleteConfirmation/DeleteConfirmation";
import { AddPaymentMethodsPage } from "components/sliderPage/manageWallet/addPaymentMethods/AddPaymentMethodsPage";
import { AccountDetail } from "components/sliderPage/accountDetail/AccountDetail";
import { ManageAccount } from "components/sliderPage/manageAccount/ManageAccount";
import { Statements } from "components/sliderPage/Statements/Statements";
import { PayByTextMain } from "components/sliderPage/payByText/PayByTextMain";

//export const promptedRoute = ["MakeAPayment"];
export const promptedRoute = [];

export const SliderLoader = () => (
  <>
    <ft-loader
      styleOverrides={JSON.stringify({ height: "65px", width: "100%" })}
      count={1}
    ></ft-loader>
    <ft-loader
      styleOverrides={JSON.stringify({ height: "105px", width: "100%" })}
      count={1}
    ></ft-loader>
    <ft-loader
      styleOverrides={JSON.stringify({ height: "40px", width: "50%" })}
      count={1}
    ></ft-loader>
    <ft-loader
      styleOverrides={JSON.stringify({ height: "20px", width: "100%" })}
      count={5}
    ></ft-loader>
    <ft-loader
      styleOverrides={JSON.stringify({ height: "40px", width: "50%" })}
      count={1}
    ></ft-loader>
    <ft-loader
      styleOverrides={JSON.stringify({ height: "20px", width: "100%" })}
      count={5}
    ></ft-loader>
    <ft-loader
      styleOverrides={JSON.stringify({ height: "40px", width: "50%" })}
      count={1}
    ></ft-loader>
    <ft-loader
      styleOverrides={JSON.stringify({ height: "20px", width: "100%" })}
      count={5}
    ></ft-loader>
  </>
);

export const SlideRoute = () => {
  const pageDetail = useRootSelector((state) => state.common.pageDetail);

  let page = null;

  if (pageDetail) {
    switch (pageDetail.id) {
      case "AddPaymentMethods":
        page = <AddPaymentMethodsPage />;
        break;
      case "Confirmation":
        page = <Confirmation />;
        break;
      case "ManageWallet":
        page = <ManageWallet />;
        break;
      case "MakeAPayment":
        page = <MakePayment />;
        break;
      case "MakeAPaymentReview":
        page = <ReviewPayment />;
        break;
      case "MakeAPaymentConfirmation":
        page = <MakeAPaymentConfirmation />;
        break;
      case "PaymentDetail":
        page = <PaymentDetail />;
        break;
      case "DeleteConfirmation":
        page = <DeleteConfirmation />;
        break;
      case "AccountDetails":
        page = <AccountDetail />;
        break;
      case "ManageAccount":
        page = <ManageAccount />;
        break;
      case "Statements":
        page = <Statements />;
        break;
      case "PayByText":
        page = <PayByTextMain />;
        break;
      default:
        page = <ComingSoon />;
    }
  }

  return <Suspense fallback={<SliderLoader />}>{page}</Suspense>;
};
